import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partnerSelect", "moduleSelect", "templateSelect"]
  static values = { templatesByModule: Object, moduleOptionsUrl: String }

  connect() {
    this.syncTemplates()
  }

  // A channel offers its own modules (independent QA: picking TestPartner still
  // listed all 56). The list is fetched for the chosen channel; the module
  // stays selected when the channel offers it too, else the field is cleared.
  async syncModules() {
    if (!this.hasPartnerSelectTarget || !this.hasModuleSelectTarget || !this.moduleOptionsUrlValue) return

    const url = new URL(this.moduleOptionsUrlValue, window.location.origin)
    if (this.partnerSelectTarget.value) url.searchParams.set("partner_id", this.partnerSelectTarget.value)
    const requested = url.toString()
    this.pendingModulesUrl = requested

    let data
    try {
      const response = await fetch(requested, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      data = await response.json()
    } catch (_e) {
      return
    }
    if (this.pendingModulesUrl !== requested) return

    const selected = this.moduleSelectTarget.value
    this.moduleSelectTarget.innerHTML = ""
    this.moduleSelectTarget.appendChild(new Option("", ""))
    data.modules.forEach(([label, id]) => this.moduleSelectTarget.appendChild(new Option(label, id)))
    this.moduleSelectTarget.value = data.modules.some(([, id]) => String(id) === selected) ? selected : ""
    this.moduleSelectTarget.dispatchEvent(new CustomEvent("options-changed", { bubbles: true }))

    this.templatesByModuleValue = data.templates_by_module || {}
    this.syncTemplates()
  }

  syncTemplates() {
    if (!this.hasModuleSelectTarget || !this.hasTemplateSelectTarget) return

    const selectedModuleId = this.moduleSelectTarget.value
    const selectedTemplateId = this.templateSelectTarget.value
    const templates = this.templatesByModuleValue[selectedModuleId] || []

    this.templateSelectTarget.innerHTML = ""
    this.templateSelectTarget.appendChild(new Option("", ""))

    templates.forEach((template) => {
      const option = new Option(`${template.id} - ${template.title}`, template.id)
      this.templateSelectTarget.appendChild(option)
    })

    if (templates.some((template) => String(template.id) === String(selectedTemplateId))) {
      this.templateSelectTarget.value = selectedTemplateId
    } else if (templates.length > 0) {
      // Default to the first template when the current selection doesn't apply
      // to the chosen module (e.g. after switching modules).
      this.templateSelectTarget.value = String(templates[0].id)
    } else {
      this.templateSelectTarget.value = ""
    }

    // Tell the searchable-select wrapping this <select> to re-read the rebuilt
    // options and refresh its visible label/list.
    this.templateSelectTarget.dispatchEvent(new CustomEvent("options-changed", { bubbles: true }))
  }
}
